import { useEffect, useState } from "react";
import LastReplyUser from "../LastReplyUser";
import MuteUser from "../MuteUser";

function MuteManager({
  nightMode,
  mutedUserIdList,
  refreshMutedUsers,
  mutedUsers,
}) {
  const [renderedMutedUserList, setRenderedMutedUserList] = useState(null);
  const [showMutedUsers, setShowMutedUsers] = useState(false);

  useEffect(() => {
    if (mutedUserIdList?.length && showMutedUsers) {
      renderMutedUsers();
    } else {
      setRenderedMutedUserList(null);
    }
  }, [mutedUserIdList, showMutedUsers]);

  const renderMutedUsers = async () => {
    const tempRender = [];
    for (let i = 0; i < mutedUserIdList.length; i++) {
      const id = mutedUserIdList[i];
      tempRender.push(
        <div
          key={id + "_muted"}
          className="flex align-items--center flex--gap-normal"
        >
          <LastReplyUser
            nightMode={nightMode}
            userId={id}
            firstText={""}
            secondText={""}
            isTiny={true}
            truncateName={true}
            clickable={true}
          />
          <MuteUser
            nightMode={nightMode}
            refreshMutedUsers={refreshMutedUsers}
            mutedUsers={mutedUsers}
            userIdToMute={id}
          />
        </div>
      );
    }
    setRenderedMutedUserList(tempRender);
  };

  return (
    <div>
      <div className="simple-divider"></div>
      <p className="description--larger bold center-text margin-auto margin-top-bigger margin-bottom-sm">
        Manage Muted Users
      </p>
      {showMutedUsers ? (
        <div className="flex flex--direction-column flex--gap-smaller align-items--center">
          <p className="description--small bold center-text padding-bottom--sm">
            Please keep in mind that users can change their
            names/aliases/pictures and they may be different from when you
            initially muted them.
          </p>
          {renderedMutedUserList}
        </div>
      ) : (
        <div className="flex flex--direction-column align-items--center">
          <button
            onClick={async (event) => {
              event.preventDefault();
              setShowMutedUsers(true);
            }}
            className="btn--register login-btn"
          >
            Show users
          </button>
        </div>
      )}
    </div>
  );
}

export default MuteManager;
